import { useEffect } from 'react';
import { initializeGTM } from '../../utils';

interface UseGTMIntegrationWithConfigProps {
  enable?: boolean;
  gtmId?: string;
  onError?: (error: any) => void;
}

const useGTMIntegrationWithConfig = ({
  enable = true,
  onError,
}: UseGTMIntegrationWithConfigProps = {}) => {
    // const gtmId = process.env.REACT_APP_GTM_ID ;
    const gtmId = process.env.REACT_APP_GTM_ID || 'GTM-MGWCQPK'; // For dev and staging, this id is available to everyone.
  useEffect(() => {
    if (!enable) return;

    try {
      if (gtmId) {
        initializeGTM(gtmId, 'dataLayer');
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing GTM:', error);
      }
      onError?.(error);
    }
  }, [enable, gtmId, onError]);

  return null;
};

export default useGTMIntegrationWithConfig; 